import React from "react"
import {
    checkUserRight,
    compose, convertFromErrorObject, getAllModalFunctions, removeEmptyFromObject,
} from "../../../utils"

import { withTranslation } from "react-i18next"
import { withTLService } from "../../hoc"
import { connect } from "react-redux"
import { Button } from "react-bootstrap"
import DataViewer from "../../elements/data-viewer"
import { bindActionCreators } from "redux"
import ModalAddEditTaskType from "../../modals/modal-add-edit-task-type"

class TaskType extends DataViewer {

    extendedFilter = true;
    /* table filters */
    tableFilters = {
        id: {
            name: 'Task ID',
            type: 'integer',
            default: undefined
        },
        name: {
            name: 'Task name',
            type: 'string',
            default: undefined
        },
        priority: {
            name: 'Priority',
            type: 'integer',
            default: undefined
        },
        owner: {
            name: 'Owner',
            type: 'integer',
            default: undefined
        },
        function: {
            name: 'Function',
            type: 'string',
            default: undefined
        },
        description: {
            name: 'Task Type description',
            type: 'string',
            default: undefined
        }
    }

    /* functions */
    functions = {
        getAll: this.props.tlService.getFilteredTaskTypes,
        massDelete: data => this.actionMassDelete(data)
    };

    /* modal components */
    modalComponents = {
        modalAdd: ModalAddEditTaskType,
        modalEdit: ModalAddEditTaskType,
    }

    /*  define count of modal*/
    modalWindowsCount = 2


    componentDidMount() {

        const {
            userData: { user },
            t: translate
        } = this.props

        /* default table columns config */
        this.columns_default = [
            {
                name: 'id',
                selector: 'id',
                sortable: true,
                grow: 0.3
            },
            {
                name: 'name',
                selector: 'name',
                grow: 0.3
            },
            {
                name: 'priority',
                selector: 'priority',
                sortable: true,
                grow: 0.3
            },
            {
                name: 'owner',
                selector: 'owner',
                sortable: true,
                grow: 0.3,
            },
            {
                name: 'function',
                selector: 'function',
                sortable: true,
                grow: 0.3
            },
            {

                name: 'description',
                selector: 'description',
                grow: 0.6
            },
            {
                name: 'Rights',
                cell: row => {
                    const right = row.rights
                    return (
                        <table className="table table-sm font-smaller">
                            <thead>
                                <tr>
                                    <th>{translate('user')}</th>
                                    <th>{translate('group')}</th>
                                    <th>{translate('company')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {right?.length > 0 && right.map(val => {
                                    if (val[0] && val[1] && val[2])
                                        return <tr key={JSON.stringify(val)}>
                                            <td>{(val[0][0] > 0 ? `${val[0][1]} (${val[0][0]})` : '-')}</td>
                                            <td>{(val[1][0] > 0 ? `${val[1][1]} (${val[1][0]})` : '-')}</td>
                                            <td>{(val[2][0] > 0 ? `${val[2][1]} (${val[2][0]})` : '-')}</td>
                                        </tr>
                                    return null
                                }

                                )}
                            </tbody>

                        </table>)
                }
            },
            {
                name: 'edit',
                cell: row => {
                    return (
                        <div className="btn-group">
                            {checkUserRight(user, [601, 602]) &&
                                (<>
                                    <Button onClick={() => this.openModal(0, row, 'modalEdit')} className="ml-2"><i
                                        className="fas fa-edit" /></Button>
                                    <Button onClick={() => this.openModal(0, row, 'modalDelete')} className="ml-2"><i
                                        className="fas fa-trash" /></Button>
                                </>)

                            }
                        </div>
                    )
                }
            }
        ]

        // check for enable page
        this.renderIt = checkUserRight(user, [161, 261])

        // check add right
        this.addButton = checkUserRight(user, [161, 261])

        /* config modal windows */
        this.modalSettings['modalAdd'] = {
            action: this.actionAdd,
            data: {
                id: false,
                name: '',
                description: '',
                function: '',
                rights: [],
                settings: {},
                shared_settings: {},
                cron: '',
                user_id: user?.id,
            },
            show: false,
            header: translate('Add Task Type'),
            footer: true,
            text: false,
            saveButton: true,
            saveButtonText: translate('Save'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        }
        this.modalSettings['modalEdit'] = {
            action: this.actionEdit,
            data: {},
            show: false,
            header: translate('Edit Task Type'),
            footer: true,
            text: false,
            saveButton: true,
            saveButtonText: translate('Save'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        }
        this.modalSettings['modalDelete'] = {
            action: this.actionDelete,
            data: {
                id: false,
            },
            show: false,
            header: translate('Delete Task Type'),
            footer: true,
            text: translate("Delete Task Type?"),
            saveButton: true,
            saveButtonText: translate('Delete'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        }
        this.modalSettings['modalMassDelete'] = {
            action: this.actionDoMassDelete,
            data: {},
            show: false,
            header: translate('Delete Selected Task Types'),
            footer: true,
            text: translate('Delete Selected Task Types'),
            saveButton: true,
            saveButtonText: translate('Delete'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        }

        /* set initial states */
        this.setState({
            filters: {},
            limits: {
                limit: 100,
                offset: 0,
                order_by: 'id',
                order: 0
            },
            page: {
                pageHeader: translate('Task Types'),
                addNewText: translate('Add new task type'),
            }
        })

        super.componentDidMount()

    }

    /* after modal action!*/

    actionAdd = async (data) => {
        const { t } = this.props
        const {
            tlService,
            userData: { token },
        } = this.props

        let id = false

        if (typeof data.settings !== "object") {
            try {
                data.settings = JSON.parse(data.settings)
            } catch (e) {
                data.settings = {}
            }
        }

        if (typeof data.shared_settings !== "object") {
            try {
                data.shared_settings = JSON.parse(data.shared_settings)
            } catch (e) {
                data.shared_settings = {}
            }
        }

        const body = {
            name: data.name, description: data.description,
            priority: parseInt(data.priority), function: data.function,
            settings: data.settings ? removeEmptyFromObject(data.settings) : {},
            shared_settings: data.shared_settings ? removeEmptyFromObject(data.shared_settings) : {},
            cron: data.cron
        }
        try {
            const ret = await tlService.addTaskType(
                token, body)

            id = ret?.data[0]?.id
        } catch (e) {
            console.log('error ' + convertFromErrorObject(t, e))
            this.setState({ error: convertFromErrorObject(t, e) })
            return false
        }

        //right
        if (data.rights.length > 0) {
            for (const right of data.rights) {
                try {
                    await tlService.addTaskTypeUGC(token, id,
                        right[0] ? parseInt(right[0][0]) : 0,
                        right[1] ? parseInt(right[1][0]) : 0,
                        right[2] ? parseInt(right[2][0]) : 0
                    )
                } catch (e) {
                    console.log('error ' + convertFromErrorObject(t, e))
                    this.setState({ error: convertFromErrorObject(t, e) })
                    return false
                }
            }
        }


        return true
    }

    actionEdit = async (data) => {
        const { t } = this.props
        const {
            tlService,
            userData: { token },
        } = this.props

        console.log("actionEdit", data)

        if (typeof data.settings !== "object") {
            try {
                data.settings = JSON.parse(data.settings)
            } catch (e) {
                data.settings = {}
            }
        }

        if (typeof data.shared_settings !== "object") {
            try {
                data.shared_settings = JSON.parse(data.shared_settings)
            } catch (e) {
                data.shared_settings = {}
            }
        }

        // prepare body
        const body = {
            name: data.name,
            description: data.description,
            priority: parseInt(data.priority),
            function: data.function,
            settings: data.settings ? removeEmptyFromObject(data.settings) : {},
            shared_settings: data.shared_settings ? removeEmptyFromObject(data.shared_settings) : {},
            cron: data.cron
        }


        try {
            await tlService.updateTaskType(
                token,
                parseInt(data.id),
                body
            )
        } catch (e) {
            console.log('error ' + convertFromErrorObject(t, e))
            this.setState({ error: convertFromErrorObject(t, e) })
            return false
        }

        // update rights

        let toDelete = []
        let toAdd
        if (data.old_rights && data.old_rights.length > 0) {
            toDelete = data.old_rights.filter(d => !data.rights.includes(d))
            toAdd = data.rights.filter(d => !data.old_rights.includes(d))
        } else {
            toAdd = data.rights
        }

        for (let right of toAdd) {
            try {
                await tlService.addTaskTypeUGC(token,
                    data.id,
                    right[0] ? parseInt(right[0][0]) : 0,
                    right[1] ? parseInt(right[1][0]) : 0,
                    right[2] ? parseInt(right[2][0]) : 0
                )
            } catch (e) {
                console.log('error ' + convertFromErrorObject(t, e))
                this.setState({ error: convertFromErrorObject(t, e) })
                return false
            }
        }
        for (let right of toDelete) {
            try {
                await tlService.deleteTaskTypeUGC(token,
                    data.id,
                    right[0] ? parseInt(right[0][0]) : 0,
                    right[1] ? parseInt(right[1][0]) : 0,
                    right[2] ? parseInt(right[2][0]) : 0
                )
            } catch (e) {
                console.log('error ' + convertFromErrorObject(t, e))
                this.setState({ error: convertFromErrorObject(t, e) })
                return false
            }
        }
        return true
    }

    actionDelete = async (data) => {
        const { t } = this.props
        const {
            tlService,
            userData: { token },
        } = this.props

        // delete TaskType
        try {
            await tlService.deleteTaskType(token, parseInt(data.id))
        } catch (e) {
            console.log('error ' + convertFromErrorObject(t, e))
            this.setState({ error: convertFromErrorObject(t, e) })
            return false
        }
        return true
    }

}

const mapStateToProps = ({ userData, modalData, openData, adminData }) => {
    return { userData, openData, modalData, adminData }
}

const mapDispatchToProps = (dispatch, { tlService }) => {
    return bindActionCreators({
        ...getAllModalFunctions(),
    }, dispatch)
}

export default compose(
    withTranslation(),
    withTLService(),
    connect(mapStateToProps, mapDispatchToProps)
)(TaskType)
